"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

require("core-js/modules/es6.function.bind.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactComponents = require("@ucloud-fe/react-components");

var _Typography = _interopRequireDefault(require("../Typography"));

var _style = require("./style");

var _excluded = ["text", "component", "showTip", "popoverProps", "containerWidth", "tipStyle"];

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * TextEllipsis.LineEllipsis
 * @description 基于容器宽度限制文本长度（仅限单行）
 */
var LineEllipsis = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(LineEllipsis, _Component);

  var _super = _createSuper(LineEllipsis);

  function LineEllipsis(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, LineEllipsis);
    _this = _super.call(this, props);
    _this.target = /*#__PURE__*/_react["default"].createRef();
    _this.state = {
      clamped: false
    };
    return _this;
  }

  (0, _createClass2["default"])(LineEllipsis, [{
    key: "isOverflown",
    value: function isOverflown() {
      return this.target.current.scrollWidth > this.target.current.clientWidth;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        clamped: this.isOverflown()
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.containerWidth !== this.props.containerWidth || prevProps.text !== this.props.text) {
        this.setState({
          clamped: this.isOverflown()
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      /* eslint-disable no-unused-vars */
      var _this$props = this.props,
          text = _this$props.text,
          component = _this$props.component,
          showTip = _this$props.showTip,
          popoverProps = _this$props.popoverProps,
          containerWidth = _this$props.containerWidth,
          tipStyle = _this$props.tipStyle,
          others = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var clamped = this.state.clamped;

      var content = /*#__PURE__*/_react["default"].createElement(_style.StyledWrapper, (0, _extends2["default"])({
        component: component,
        ref: this.target
      }, others), text);

      if (showTip && clamped) {
        return /*#__PURE__*/_react["default"].createElement(_reactComponents.Tooltip, (0, _extends2["default"])({
          popup: /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
            size: "sm",
            style: tipStyle
          }, text),
          getPopupContainer: function () {
            (0, _newArrowCheck2["default"])(this, _this2);
            return document.body;
          }.bind(this)
        }, popoverProps, {
          arrow: false
        }), content);
      }

      return content;
    }
  }]);
  return LineEllipsis;
}(_react.Component);

LineEllipsis.propTypes = {
  /**
   * 需要展示的文本
   */
  text: _propTypes["default"].string.isRequired,

  /**
   * 设置标签类型
   */
  component: _propTypes["default"].elementType,

  /**
   * 是否在被截断后，通过鼠标移入浮层展示完整文本
   */
  showTip: _propTypes["default"].bool,

  /**
   * 鼠标移入浮层基于基础组件Popover的props
   */
  popoverProps: _propTypes["default"].object,

  /**
   * 鼠标移入浮层的样式
   */
  tipStyle: _propTypes["default"].object,

  /**
   * 容器的宽度（用于更新是否限制宽度的判断）
   */
  containerWidth: _propTypes["default"].number,

  /**
   * 自定义类名
   */
  className: _propTypes["default"].string
};
LineEllipsis.defaultProps = {
  component: "div",
  showTip: true,
  popoverProps: {},
  tipStyle: {}
};
var _default = LineEllipsis;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/TextEllipsis/LineEllipsis.js
// module id = 2114
// module chunks = 6 7 17 18